import type { FC, HTMLAttributes, ReactNode } from 'react';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import { GraphModal } from '../../components/GraphModal/GraphModal';
import { clearYakli } from '../../redux/slices/yakli-slice';
import { YakliDiscussion } from './YakliDiscussion';

interface YakliDiscussionModalProps extends HTMLAttributes<HTMLDivElement> {
  poper: ReactNode;
  slug: string;
  messageId: string;
  onClose?: () => void;
}

export const YakliDiscussionModal: FC<YakliDiscussionModalProps> = memo(
  function YakliDiscussionModal({ poper, className, slug, messageId, onClose, ...otherProps }) {
    return (
      <div className={twMerge('YakliDiscussionModal', className)} {...otherProps}>
        <GraphModal
          lazyContent={() => (
            <YakliDiscussion slug={slug} messageId={messageId} onClose={onClose} />
          )}
          showPageOverlay
          forceModal
          contentClassName="max-w-[790px]"
          onHide={clearYakli}
        >
          {poper}
        </GraphModal>
      </div>
    );
  },
);
